export const X_EAM_AUTHN_STATE = 'X-EAM-Authn-State';
